import { Box, Button, Chip, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';
import ToolTip from '../../../ToolTip/ToolTip';
import { CreatedAt } from '../../../../utils/constants/CreatedAt';
import OGARemarks from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/OGAremarks';
import CartItemEdit from '../../../../views/ogd/myworkspace/Cart/CartEdit/CartItemEdit';
import ForecastUpdate from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/ForecastUpdate';
import NonCartEdit from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/NonCartEdit';
import AddRetention from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/AddRetention';
import DeleteCourseEnrollment from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/DeleteCourseEnrollment';

export const NewCrdAdmissionRegisterTableHead = (
  crm,
  finance,
  dispatchParams = {},
  setOpenModalComponentName,
  setSelectedForActivating,
  cro,
) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
  },
  {
    field: 'is_student_new',
    headerName: 'Student Type',
    renderCell: (params) => {
      return params.row.is_student_new ? 'New Admission' : 'Old Admission';
    },
    width: 130,
  },
  {
    field: 'exists_in_cart',
    headerName: 'Exists in Cart',
    width: 100,
    renderCell: (params) => {
      return params.row.exists_in_cart === 1 ? 'Yes' : 'No';
    },
  },
  ...(crm
    ? [
        {
          field: 'non_cart_edit',
          headerName: 'Non Cart Edit',
          width: 200,
          renderCell: (params) => {
            return <NonCartEdit rowData={params.row} />;
          },
        },
      ]
    : []),
  ...(crm || cro
    ? [
        {
          field: 'retention',
          headerName: 'Upsell',
          width: 150,
          renderCell: (params) => <AddRetention row={params.row} dispatchParams={dispatchParams} />,
        },
        {
          field: 'deleteCourse',
          headerName: 'Delete Course',
          width: 150,
          renderCell: (params) => <DeleteCourseEnrollment row={params.row} dispatchParams={dispatchParams} />,
        },
      ]
    : []),
  {
    field: 'student_region',
    headerName: 'Student Region',
    width: 150,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 150,
    sortable: true,
  },
  {
    field: 'student_name',
    headerName: 'Name',
    width: 250,
    sortable: true,
  },
  {
    field: 'class_name',
    headerName: 'Class',
    width: 170,
  },
  {
    field: 'student_mob_no',
    headerName: 'Mobile',
    width: 170,
  },
  {
    field: 'sro_name',
    headerName: 'OGA Name',
    width: 250,
  },
  {
    field: 'croName',
    headerName: 'CRO Name',
    width: 250,
  },
  {
    field: 'cro_assignment_timestamp',
    headerName: 'CRM Assigned On',
    width: 250,
    renderCell: (params) => {
      return CreatedAt(params.row.cro_assignment_timestamp, false);
    },
  },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    width: 170,
  },
  {
    field: 'assessment_report_count',
    headerName: 'Assessmet Report Count',
    width: 150,
  },
  {
    field: 'current_class',
    headerName: 'Current Class',
    width: 150,
  },
  {
    field: 'syllabus_name',
    headerName: 'Syllabus',
    width: 170,
  },
  {
    field: 'course_enrollment_id',
    headerName: 'Course Enrollment Id',
    width: 170,
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    renderCell: (params) => {
      return <ToolTip expand={params.row.course_name} content={params.row.course_name} />;
    },
  },
  {
    field: 'course_batch_name',
    headerName: 'Batch',
    width: 170,
  },
  {
    field: 'course_enrollment_timestamp',
    headerName: 'Course Enrollment Date',
    width: 170,
    renderCell: (params) => {
      return CreatedAt(params.row.course_enrollment_timestamp, false);
    },
  },
  {
    field: 'course_enrollment_age',
    headerName: 'Course Enrollment Age (No of days)',
    width: 150,
    renderCell: (params) => {
      return `${params?.row?.course_enrollment_age} Days`;
    },
  },
  //   {
  //     field: "expected_course_completion",
  //     headerName: "Expected Course Completion(TI)",
  //     width: 230,
  //     renderCell: (params) => {
  //       const totalSessions = parseInt(params.row.total_sessions);
  //       let sessionsPerWeek = parseInt(params.row.sro_class_per_week);
  //       const enrollmentDate = new Date(params.row.course_enrollment_timestamp);

  //       if (params.row.sro_class_per_week && sessionsPerWeek !== 0 && params.row.total_sessions ) {
  //         if (sessionsPerWeek > 5) sessionsPerWeek = 5;

  //         let totalDays = (totalSessions / sessionsPerWeek) * 7;

  //         if (totalDays % 5 !== 0) {
  //           totalDays = (Math.floor(totalDays / 5) + 1) * 5;
  //         }

  //         const completionDate = new Date(enrollmentDate);
  //         completionDate.setDate(enrollmentDate.getDate() + totalDays);

  //         const formattedDate = completionDate.toLocaleDateString("en-GB"); // dd/mm/yyyy format
  //         return formattedDate;
  //       }

  //       return "N/A";
  //     },
  //   },
  {
    field: 'levels_opted',
    headerName: 'Course Level',
    width: 230,
    valueGetter: ({ value, row }) => (row?.project_name === 'Classroom' ? 'N/A' : value),
  },
  {
    field: 'total_sessions',
    headerName: 'Total Sessions',
    width: 170,
  },

  ...(!finance
    ? [
        {
          field: 'expected_sessions',
          headerName: 'Expected Sessions',
          width: 150,
        },
      ]
    : []),
  {
    field: 'sessions_completed',
    headerName: 'Sessions Completed',
    width: 150,
  },
  {
    field: 'first_session_date',
    headerName: 'First Session Date',
    width: 150,
  },
  {
    field: 'last_session_date',
    headerName: 'Last Session Date',
    width: 150,
  },
  ...(crm
    ? [
        {
          field: 'expected_completion_date',
          headerName: 'Expected Course Completion',
          width: 150,
          valueGetter: ({ value }) => value ?? 'Calendar Not Set',
        },
      ]
    : []),
  {
    field: 'first_fee_date',
    headerName: 'First Fee Paid On',
    width: 150,
  },
  {
    field: 'total_sales_amount',
    headerName: 'Total Sales Amount',
    width: 150,
  },
  {
    field: 'total_fee_collected',
    headerName: 'Total Fee Collected',
    width: 150,
  },
  {
    field: 'course_inactive_date',
    headerName: 'Course Inactive Date',
    width: 150,
  },
  // {
  //     field: "Link",
  //     headerName: "Classroom  Materials(link)",
  //     width: 150,
  // },
  // {
  //     field: "academiccALENDAER",
  //     headerName: "Admission Calendar Available",
  //     width: 150,
  // },
  {
    field: 'sro_remarks',
    headerName: 'OGA Remarks',
    width: 200,
    renderCell: (params) => {
      return (
        <Tooltip title={params.row.sro_remarks} arrow>
          <Box>
            <OGARemarks CROAssignID={params.row.cro_assignment_id} />
          </Box>
        </Tooltip>
      );
    },
  },

  {
    field: 'cro_notes',
    headerName: 'CRO Notes',
    width: 250,
    renderCell: (params) => {
      return <ToolTip expand={params.row.cro_notes} content={params.row.cro_notes} />;
    },
  },
  {
    field: 'admission_fee_status',
    headerName: 'Admission Fee',
    width: 150,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={params.row.admission_fee_status === 1 ? 'success' : 'warning'}
          label={params.row.admission_fee_status == 1 ? 'Paid' : 'Not Paid'}
          variant="outlined"
          icon={
            params.row.admission_fee_status === 1 ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
  },
  {
    field: 'admission_status',
    headerName: 'Admission Status',
    width: 190,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={
            params.row.admission_status === 1
              ? 'success'
              : 'info' && params.row.admission_status === 2
                ? 'warning'
                : 'info' && params.row.admission_status === 0
                  ? 'error'
                  : 'info'
          }
          label={
            params.row.admission_status == 1
              ? 'Active'
              : params.row.admission_status == 2
                ? 'Temporarly Inactive'
                : 'Inactive'
          }
          variant="outlined"
          icon={
            params.row.admission_status === 1 ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
  },

  {
    field: 'mappingStatus',
    headerName: 'Mapping Status',
    width: 180,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={
            params.row.mapping_status === 2
              ? 'success'
              : params.row.mapping_status === 1
                ? 'warning'
                : params.row.mapping_status === 0
                  ? 'error'
                  : 'info'
          }
          label={
            params.row.mapping_status === 2
              ? 'Completed'
              : params.row.mapping_status === 1
                ? 'Partially Completed'
                : params.row.mapping_status === 0
                  ? 'Not Completed'
                  : ''
          }
          variant="outlined"
          icon={
            params.row.mapping_status === 2 ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
  },
  {
    field: 'preference_status',
    headerName: 'Preference Status',
    width: 150,
    renderCell: (params) => {
      return (
        <Chip
          size="small"
          color={params.row.preference_status ? 'success' : 'warning'}
          label={params.row.preference_status ? 'Yes' : 'No'}
          variant="outlined"
          icon={
            params.row.preference_status ? (
              <Icon icon="mdi:tick" />
            ) : (
              <Icon icon="basil:cross-outline" height="20" width="20" />
            )
          }
        />
      );
    },
  },
  {
    field: 'fee_term_informed_by_name',
    headerName: 'Fee term informed by',
    width: 200,
    renderCell: (params) => {
      return params.row.fee_term_informed_by_name === null ? 'N/A' : params.row.fee_term_informed_by_name;
    },
  },
  {
    field: 'fee_term_informed_timestamp',
    headerName: 'Fee term informed on',
    width: 200,
    renderCell: (params) => {
      return params.row.fee_term_informed_timestamp === null ? 'N/A' : params.row.fee_term_informed_timestamp;
    },
  },
  {
    field: 'cart_item_selected_option',
    headerName: 'Forecast Method',
    width: 150,
    renderCell: (params) => {
      return params.row.cart_item_selected_option === null ? 'Manual' : 'System';
    },
  },
  ...(finance
    ? [
        {
          field: 'forecast_changed_by',
          headerName: 'Forecast Changed By',
          width: 200,
          renderCell: (params) => {
            return params.row.forecast_changed_by === null ? 'N/A' : params.row.forecast_changed_by;
          },
        },
      ]
    : []),
  ...(finance
    ? [
        {
          field: 'forecast_modified_at',
          headerName: 'Changed On',
          width: 200,
          renderCell: (params) => {
            return params.row.forecast_modified_at === null ? 'N/A' : params.row.forecast_modified_at;
          },
        },
      ]
    : []),
  ...(crm
    ? [
        {
          field: 'forecast_update',
          headerName: 'Forecast Break',
          width: 200,
          renderCell: (params) => <ForecastUpdate dispatchParams={dispatchParams} row={params.row} />,
        },
      ]
    : []),
  ...(crm || finance
    ? [
        {
          field: 'cart_edit',
          headerName: 'Cart Edit',
          width: 200,
          renderCell: (params) => <CartItemEdit row={params.row} />,
        },
      ]
    : []),
  ...(crm
    ? [
        {
          field: 'active',
          headerName: 'Course Activation',
          width: 200,
          renderCell: ({ row }) => (
            <Button
              variant="contained"
              color="info"
              onClick={() => {
                setSelectedForActivating({
                  // name: row?.student_name,
                  id: row?.course_enrollment_id,
                  status: row?.admission_status,
                });
                setOpenModalComponentName('Course Enrollment Status');
              }}
            >
              Edit Status
            </Button>
          ),
        },
      ]
    : []),
];
